export default __webpack_public_path__ + "static/media/check-circle.6ecefe4e.svg";